const API_BASE_URL = "https://bluuapi.bcr.co.za";
const SCANNER_API_BASE_URL = "https://scanner.bcr.co.za";
const API_VERSION = "v2";

export const API_ROUTES = {
  AUTHENTICATION: {
    REGISTER: `${API_BASE_URL}/api/${API_VERSION}/Authentication/register`,
    LOGIN: `${API_BASE_URL}/api/${API_VERSION}/Authentication/login`,
    REFRESH: `${API_BASE_URL}/api/${API_VERSION}/Authentication/refresh-token`,
    ACTIVATE: `${API_BASE_URL}/api/${API_VERSION}/Authentication/activate`,
    UPDATE: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Authentication/update/${email}`;
    },
    PASSWORD_UPDATE: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Authentication/password-update/${email}`;
    },
    VERIFY_ACCOUNT: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Authentication/activate/${email}`;
    },
    VERIFY_OTP: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Authentication/otp/${email}`;
    },
    DELETE_ACCOUNT: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Authentication/delete-account/${email}`;
    },
    SECURITY_QUESTIONS: `${API_BASE_URL}/api/${API_VERSION}/Authentication/security`,
    GUEST_LOGIN: `${API_BASE_URL}/api/${API_VERSION}/Authentication/guest-login`,
    VERIFY_GUEST_LOGIN: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Authentication/guest-otp/${email}`;
    },
    GETUSERINFO: `${API_BASE_URL}/api/${API_VERSION}/Authentication/get-user-info`,
  },
  BRANCHES: {
    ALL: `${API_BASE_URL}/Branches`,
    DETAIL: function (branchCode) {
      return `${API_BASE_URL}/Branches/${branchCode}`;
    },
  },
  BOOKING: {
    AVAILABILITY: `${API_BASE_URL}/Booking/availability`,
    BOOK: `${API_BASE_URL}/Booking/booking`,
    CANCELLED: `${API_BASE_URL}/Booking/cancel`,
    PRODUCTS: function (accountType, pickUpBranch, vehicleGroup) {
      return `${API_BASE_URL}/Product/additional/${accountType}/${pickUpBranch}/${vehicleGroup}`;
    },
    QUOTE: `${API_BASE_URL}/Quote`,
    STATUS: function (bookingId) {
      return `${API_BASE_URL}/Booking/status/${bookingId}`;
    },
    RESERVATION: function (reservationId) {
      return `${API_BASE_URL}/Booking/reservation/${reservationId}`;
    },
    BOOKING: function (bookingId) {
      return `${API_BASE_URL}/Booking/booking/${bookingId}`;
    },
    // REQUESTEXTESION: function () {
    //   //const API_BASE_URL_EXTENTION = API_BASE_URL_EXTENTION;
    //   return {
    //     url: API_BASE_URL_EXTENTION,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "application/json",
    //     },
    //   };
    // },

    MANAGE: function (quoteNo, email) {
      return `${API_BASE_URL}/Booking/manage/${quoteNo}/${email}`;
    },
    GET_RESERVATION: function (quoteNo, email) {
      return `${API_BASE_URL}/reservation/${quoteNo}/${email}`;
    },
    USER: function (email) {
      return `${API_BASE_URL}/Booking/user/${email}`;
    },
    INDIVIDUAL: function (email) {
      return `${API_BASE_URL}/api/${API_VERSION}/Bookings/individual/${email}`;
    },
    INDIVIDUAL_STATUS: function (email, status) {
      return `${API_BASE_URL}/api/${API_VERSION}/Bookings/individual/${email}/${status}`;
    },
    CUSTOMER: function (customerCode) {
      return `${API_BASE_URL}/api/${API_VERSION}/Bookings/customer/${customerCode}`;
    },
    AUTHORIZE: `${API_BASE_URL}/api/${API_VERSION}/Bookings/authorize`,
  },
  CUSTOMER: {
    ACCOUNTS: `${API_BASE_URL}/Customer/accounts`,
    INFORMATION: `${API_BASE_URL}/Customer/information`,
    VOUCHER: function (accountNo) {
      return `${API_BASE_URL}/Customer/voucher/${accountNo}`;
    },
  },
  QUOTE: {
    SAVE: `${API_BASE_URL}/Quote/save`,
    MODIFY: function (quoteNo, email) {
      return `${API_BASE_URL}/Quote/${quoteNo}/${email}`;
    },
    QUOTE: function (quoteNo, email) {
      return `${API_BASE_URL}/Quote/${quoteNo}/${email}`;
    },
    USER: function (email) {
      return `${API_BASE_URL}/Quote/user/${email}`;
    },
  },
  DOOR2DOOR: {
    AVAILABILITY: `${API_BASE_URL}/Booking/d2d/availability`,
    RATES: {
      ALL: `${API_BASE_URL}/Booking/d2d/rates`,
      BY_ACCOUNT: function (accountId) {
        return `${API_BASE_URL}/Booking/d2d/rates/${accountId}`;
      },
    },
    QUOTE: `${API_BASE_URL}/Quote/d2d`,
    BOOK: `${API_BASE_URL}/Booking/d2d/booking`,
    SAVE: `${API_BASE_URL}/Quote/d2d/save`,
    MODIFY: function (quoteNo, email) {
      return `${API_BASE_URL}/Quote/d2d/${quoteNo}/${email}`;
    },
    RETRIEVEQUOTE: function (quoteNo, email) {
      return `${API_BASE_URL}/Quote/d2d/${quoteNo}/${email}`;
    },
  },
  USER: {
    LOGIN: `${API_BASE_URL}/User`,
    PASSWORD_TOKEN: `${API_BASE_URL}/User`,
    FORGOT_PASSWORD: `${API_BASE_URL}/User`,
    REGISTER: `${API_BASE_URL}/User`,
    LICENSE_DECRYPT: `${SCANNER_API_BASE_URL}/api/v2/drivers/decrypt`,
  },
  DEVICE: {
    REGISTER: `${API_BASE_URL}/api/v2/Notification/register`,
    DELETE: function (email, deviceId) {
      return `${API_BASE_URL}/api/v2/Notification/delete/${email}/${deviceId}`;
    },
    NOTIFICATIONS: function (email) {
      return `${API_BASE_URL}/api/v2/Notification/list/${email}`;
    },
  },
  KEYLESS: {
    ENQUIRY: `${API_BASE_URL}/api/v2/Keyless/enquiry`,
    UNLOCK_DRIVER_DOOR: `${API_BASE_URL}/api/v2/Keyless/unlock-driver-door`,
    UNLOCK_ALL_DOORS: `${API_BASE_URL}/api/v2/Keyless/unlock-all-doors`,
    UNLOCK_BOOT: `${API_BASE_URL}/api/v2/Keyless/unlock-boot`,
    LOCK_ALL_DOORS: `${API_BASE_URL}/api/v2/Keyless/lock-all-doors`,
    LOCK_BOOT: `${API_BASE_URL}/api/v2/Keyless/lock-boot`,
    TERMINATE_CONTRACT: `${API_BASE_URL}/api/v2/Keyless/terminate-contract`,
    LOCATE_VEHICLE: `${API_BASE_URL}/api/v2/Keyless/locate`,
    LOCK_DRIVER_DOOR: `${API_BASE_URL}/api/v2/Keyless/lock-driver-door`,
  },
  SENDMAIL: {
    BOOKING: `${API_BASE_URL}/email`,
  },
  SENDMAIL: {
    BOOKING: `${API_BASE_URL}/email`,
  },
  PAYMENTGATEWAY: {
    VALIDATE: (data) =>
      `${API_BASE_URL}/api/PaymentGateway/validate-payment?data=${data}`,
  },
};
